module.exports = __webpack_public_path__ + "img/fullscreen.1243751d.svg";